import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Gauge, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MONTHLY_KEYS, QUOTA_KEYS, planName, quotaLabel } from "@/components/billing/PlanCards";
import api from "@/lib/api";
import { t } from "@/i18n";

export const WARN_RATIO = 0.8;
const period = () => new Date().toISOString().slice(0, 7);
const dismissKey = (kind, plan) => `mmp_qbanner_${period()}_${plan}_${kind}`;

export function QuotaBanner() {
  const { pathname } = useLocation();
  const [hit, setHit] = useState(null);

  useEffect(() => {
    if (pathname === "/settings") return setHit(null);
    api.get("/billing").then(({ data: b }) => {
      const kind = QUOTA_KEYS.find((k) => b.limits[k] && (b.usage[k] ?? 0) / b.limits[k] >= WARN_RATIO && !localStorage.getItem(dismissKey(k, b.plan)));
      setHit(kind ? { kind, plan: b.plan, used: b.usage[kind], limit: b.limits[kind] } : null);
    }).catch(() => {});
  }, [pathname]);

  if (!hit) return null;
  const dismiss = () => { localStorage.setItem(dismissKey(hit.kind, hit.plan), "1"); setHit(null); };
  const monthly = MONTHLY_KEYS.includes(hit.kind);
  const key = monthly ? "qbanner.text_monthly" : "qbanner.text";
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-2xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm" data-testid="quota-banner">
      <Gauge className="h-5 w-5 shrink-0 text-amber-500" />
      <p className="min-w-0 flex-1" data-testid="quota-banner-text">
        {t(key, { used: hit.used, limit: hit.limit, label: monthly ? t(hit.limit === 1 ? `quota.label1_${hit.kind}` : `quota.label_${hit.kind}`) : quotaLabel(hit.kind, hit.limit), plan: planName(hit.plan) })}
      </p>
      <Button size="sm" asChild data-testid="quota-banner-cta"><Link to="/tarifs">{t("qbanner.cta")}</Link></Button>
      <button type="button" onClick={dismiss} aria-label={t("qbanner.dismiss")} className="rounded-md p-1 text-muted-foreground hover:text-foreground" data-testid="quota-banner-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
